module.exports = __webpack_public_path__ + "img/tridimensionales.6ff5e83c.png";